import { ReactElement } from "react";
import { checkIsMaximumDiscount, getNextPromoCode } from "../app/utils/promocode";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { CommonState } from "../app/interfaces/common";
import { incrementCodeShown, saveCode, setConfirm } from "../app/slices/appSlice";
import { Button } from "./Button";
import { Pipes } from "./Pipes";
import { ymEvent } from "../app/utils/metrix";

export const GamePromoOdePopup = (): ReactElement => {
  const dispatch = useAppDispatch()
  const { email, code, showConfirm } = useAppSelector((state: CommonState) => state.app)
  const discount = getNextPromoCode(code)
  const isMaximumDiscount = checkIsMaximumDiscount(discount)

  const content = (() => {
    if (showConfirm) {
      return (
        <>
          <h1 className={'headline headline_popup'}>Ты действительно <br className={'mob'}/> хочешь <br className={'desk'}/> забрать промокод?</h1>
          <div>
            <p>
              Один пользователь может <br className={'mob'}/> получить <br className={'desk'}/> всего один промокод
            </p>
          </div>
          <div className={'promo-buttons'}>
            <Button cssClass={'button_long-text button_lined button_pink'}
                    clickEvent={() => {
                      ymEvent('yes_click')
                      dispatch(saveCode({email: email, type: discount.value}))
                    }}>Да</Button>
            <Button cssClass={'button_long-text button_lined button_green'}
                    clickEvent={() => dispatch(incrementCodeShown())}>Продолжить игру</Button>
          </div>
        </>
      )
    } else {
      const buttons = (() => {
        if (isMaximumDiscount) {
          return <Button cssClass={'mtm_1 button_long-text button_pink'}
                         clickEvent={() => {
                           ymEvent('get_promo_code_click')
                           dispatch(saveCode({email: email, type: discount.value}))
                         }}>Забрать промокод</Button>
        } else {
          return (
            <div className={'promo-buttons'}>
              <Button cssClass={'button_long-text button_lined button_pink'}
                      clickEvent={() => {
                        ymEvent('get_promo_code_click')
                        dispatch(setConfirm(true))
                      }}>Забрать промокод</Button>
              <Button cssClass={'button_long-text button_lined button_green'}
                    clickEvent={() => dispatch(incrementCodeShown())}>Продолжить игру</Button>
            </div>
          )
        }
      })()
      return (
        <>
          <h1 className={'headline headline_popup ' + (isMaximumDiscount ? 'headline_max' : '')}>Поздравляем,<br/> ты
            выжал {isMaximumDiscount ? "максимальную" : ''} выгоду в {discount.value}!</h1>
          <div>
            <p>
              Промокод сработает при покупке <br/> от {discount.purchase} рублей
            </p>
          </div>
          {buttons}
        </>
      )
    }
  })()

  return (
    <div className={'popup'}>
      <div className={'popup__overflow'}></div>
      <div className={'popup__content'}>
        <div className={'percent-gear percent-gear_' + code}></div>
        <div className={'popup__content-white-bg'}/>
        <div className={'popup__stuff-over-bg'}>
          {content}
        </div>
        <Pipes/>
      </div>
    </div>
  )
}